import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";

const RestoreProductExclusionMutation = graphql(`
  mutation RestoreProductExclusion($id: ID!) {
    restoreProductExclusion(id: $id) {
      id
      __typename
      clientId
      productId
      reason
      validTo
      restoredAt
    }
  }
`);

export function useRestoreProductExclusion() {
  const [result, restoreProductExclusionMutation] = useMutation(RestoreProductExclusionMutation);
  const [error, setError] = useState<Error | null>(null);

  const restoreProductExclusion = useCallback(
    async (id: string) => {
      try {
        const response = await restoreProductExclusionMutation({ id });
        if (response.error) {
          throw response.error;
        }
        setError(null);
        return response.data?.restoreProductExclusion;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [restoreProductExclusionMutation],
  );

  return { restoreProductExclusion, result, error };
}
